import React from 'react';
import { browserHistory } from 'react-router';
import * as styles from './ContentBucketDetail.scss';

function ContentBucketDetail(props) {
  var categorySlug = props.categorySlug,
      bucketDetail = props.bucketDetail,
      orgId = props.orgId;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrap
  }, bucketDetail.Categories.map(function (c, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "bucketDetail_".concat(index, "_").concat(c.id),
      className: styles.bucketChipWrap,
      style: c.slug === categorySlug ? {
        backgroundColor: 'rgba(0,0,0,0.2)'
      } : {},
      onClick: function onClick() {
        browserHistory.push("/org/".concat(orgId, "/content/bucket/").concat(bucketDetail.slug, "/category/").concat(c.slug));
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: c.avatarImageUrl,
      className: styles.image
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, c.tagName));
  }));
}

ContentBucketDetail.defaultProps = {};
export default ContentBucketDetail;